import { STATUS_MAP } from "@/lib/pos/global";
import type { OrderWithItems } from "@/types/pos";
import pendingImgae from "@/assets/pos/pending.gif";
import preparingImage from "@/assets/pos/preparing.gif";
import readyImage from "@/assets/pos/ready.gif";


export default function OrderStatusBanner({ orders, onOpenHistory }: { orders: OrderWithItems[]; onOpenHistory: ()=> void; }) {
  if (!orders?.length) return null;

  const STATUS_GIF_MAP: Record<string, string> = {
    pending: pendingImgae,
    preparing: preparingImage,
    ready: readyImage,
  };

  // filter only active orders (exclude delivered and cancelled)
  const activeOrders = orders
    .filter(o => o.status !== "delivered" && o.status !== "cancelled")
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

  const current = activeOrders[0];
  if (!current) return null;

  const status = current.status.toLowerCase();
  const meta = STATUS_MAP[status];
  const gif = STATUS_GIF_MAP[status];

  if (!meta) return null;

  const Icon = meta.Icon;

  return (
    <div className="fixed bottom-[68px] left-0 right-0 z-40" onClick={onOpenHistory}>
      <div className="max-w-5xl mx-auto px-5">
        <div className="px-4 py-3 rounded-xl shadow-lg flex items-center gap-3 bg-[var(--pos-secondary-background-color)]">
          {gif ? (
            <img
              src={gif}
              alt={status}
              className="w-[40px] object-contain"
            />
          ) : (
            <button className="rounded-full p-2 bg-[var(--pos-primary-background-color)]">
              <Icon className={`h-5 w-5 ${meta?.textColor}`} />
            </button>
          )}
          <div className="flex flex-col text-[var(--pos-primary-text-color)]">
            <span className={`text-sm font-medium`}>{meta.label}</span>
            <span className="text-[12px] text-[var(--pos-secondary-text-color)]">{`Hang tight! Your delicious order is being ${meta.key}.`}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
